import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';
import classNames from 'classnames';
import './BackgroundLayer.module.css';

class BackgroundLayer extends PureComponent {
  render() {
    const {
      imageUrl,
      imageAlign,
      backgroundColor,
      darkOverlay,
      bgHeight,
      children,
      heightRestrict
    } = this.props;
    // if (window.innerWidth >= 1920) {
    //   imageSizefix = `calc(1920px *  (${imageSize} / 100) + ( (100vw - 1920px) / 2) )`;
    // }
    let imageAlignTranslate = 'center';
    if (imageAlign === 'right') {
      imageAlignTranslate = 'right';
    }
    if (darkOverlay) {
      return (
        <div
          styleName={classNames('background-layer', {
            'restrict-height': heightRestrict
          })}
          style={{
            background: `linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5)) ${imageAlignTranslate} no-repeat, url(${imageUrl}) ${imageAlignTranslate} no-repeat`,
            backgroundColor,
            backgroundSize: `cover, cover, 100% 100%`,
            height: bgHeight ? `${bgHeight}vw` : 'auto'
          }}
        >
          {children}
        </div>
      );
    }
    return (
      <div
        styleName={classNames('background-layer', {
          'restrict-height': heightRestrict
        })}
        style={{
          background: `url(${imageUrl}) ${imageAlignTranslate} no-repeat, ${backgroundColor}`,
          backgroundSize: `cover`,
          height: bgHeight ? `${bgHeight}vw` : 'auto'
        }}
      >
        {children}
      </div>
    );
  }
}

BackgroundLayer.propTypes = {
  imageUrl: PropTypes.string,
  imageAlign: PropTypes.string,
  backgroundColor: PropTypes.string,
  darkOverlay: PropTypes.bool,
  bgHeight: PropTypes.number,
  children: PropTypes.node
};

export default DisplayComponent(BackgroundLayer);
